
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import Validate from "../../../../dev/helpers/validate";
import formsNames from '../../../../dev/constants/formsNames';
import {Login} from "../../../../dev/actions/login";
import {UIMixin} from '../../../../dev/mixins/uiMixin';
import Config from '../../../../dev/config/main';
import Helpers from '../../../../dev/helpers/helperFunctions';
import { LoginAdmin } from "../../../actions/terminal";
import PropTypes from "prop-types";

class LoginForm extends Component {

    constructor (props) {
        super(props);
        this.doLogin = this.doLogin.bind(this);
    }
    /**
     * @name doLogin
     * @description login user
     * @param values
     * @returns {undefined}
     * */
    doLogin (values) {
        (this.props.popupParams.signInToAdmin || values["login-name"].includes("#"))
            ? this.props.dispatch(LoginAdmin({username: values["login-name"], password: values.password}))
            : this.props.dispatch(Login(values['login-name'], values.password, !!values.remember));
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }

    componentDidMount () {
        if (this.props.popupParams && this.props.popupParams.disable) {
            this.interval = setTimeout(() => {
                this.props.openPopup(this.props.popupParams.from, {disable: this.props.popupParams.disable, data: this.props.popupParams.data})();
            }, 50000);
        }
    }
    componentWillUnmount () {
        clearTimeout(this.interval);
    }
}

LoginForm.propTypes = {
    popupParams: PropTypes.object,
    openPopup: PropTypes.func
};

function mapStateToProps (state, ownParams) {
    return {
        user: state.user,
        initialValues: {remember: true},
        popupParams: state.uiState.popupParams,
        ownParams: ownParams
    };
}

const validate = values => {
    const errors = {};
    Validate(values["login-name"], "login-name", "required", errors);
    if (Helpers.CheckIfPathExists(Config, "main.loginConfig.fields.loginName.customAttrs.regex")) {
        Validate(values["login-name"], "login-name", ["regex", Config.main.loginConfig.fields.loginName.customAttrs.regex], errors, Config.main.loginConfig.fields.loginName.validationMessages && Config.main.loginConfig.fields.loginName.validationMessages.regex);
    }
    Validate(values.password, "password", "required", errors);
    return errors;
};

export default connect(mapStateToProps)(UIMixin({Component: reduxForm({form: formsNames.loginForm, validate})(LoginForm)}));